// @ts-nocheck

import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import { AutoScrollAnchor } from '../../styled-components/shared';
import { type FacetType } from '../../types/facets';
import { Routes } from '../../types/routes';
import { type Route } from '../../types/routes';
import DocumentTitle from '../DocumentTitle';
import MatchRowList from '../MatchRowList';
import MatchRowsFilters from '../MatchRowsFilters';
import NotFoundView from '../NotFoundView';
import WinaLoader from '../WinaLoader';

export const LIVE_ROUTE_ANCHOR_ID = 'live-route-anchor';

const FilteredNotFoundView = styled(NotFoundView)`
  padding-top: 8em;
  height: 100%;
`;

type RoutesLiveProps = {
  isLoading: boolean;
  list: Array<unknown>;
  facets: Array<FacetType>;
  prefs: Dictionary<string>;
  setPreferences: (prefs: unknown) => void;
  askRoute: (route: Route) => void;
  anchorMatchId?: number;
};

const RoutesLive = ({ isLoading, list, facets, prefs, setPreferences, askRoute, anchorMatchId }: RoutesLiveProps) => {
  const [scrollTop, setScrollTop] = useState(false);
  const hasAnyResult = useMemo(() => !!facets?.filter((facet) => facet.count > 0)?.length, [facets]);

  useEffect(() => {
    askRoute(Routes.LIVE);
  }, [askRoute]);

  if (isLoading) {
    return (
      <DocumentTitle title={__('!desc:DocumentTitleLive')}>
        <WinaLoader delayed />
      </DocumentTitle>
    );
  }

  return (
    <DocumentTitle title={__('!desc:DocumentTitleLive')}>
      <section className="event-list">
        <AutoScrollAnchor data-anchorid={LIVE_ROUTE_ANCHOR_ID} />
        {hasAnyResult ? (
          <React.Fragment>
            <MatchRowsFilters
              facets={facets}
              prefs={prefs}
              setPreferences={setPreferences}
              setScrollTop={setScrollTop}
            />
            {list?.length ? (
              <MatchRowList
                items={list}
                anchorMatchId={anchorMatchId}
                scrollTop={scrollTop}
                setScrollTop={setScrollTop}
              />
            ) : (
              <FilteredNotFoundView label={__('No results')} hideButton />
            )}
          </React.Fragment>
        ) : null}
        {!hasAnyResult ? <NotFoundView label={__('no events')} /> : null}
      </section>
    </DocumentTitle>
  );
};

export default RoutesLive;
